// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1lpfi","paramInput":"JobSimulator_paramInput__O89Rj","input":"JobSimulator_input__2YO3p"};